module.exports = __webpack_public_path__ + "img/icon_tag.a26feafc.png";